import React from "react";
import { styled } from "@mui/material";
import { transientOptions } from "../../../styles/theme";
import { FlexContainer } from "../../../components/styled";

const LetterContainer = styled(FlexContainer, transientOptions)`
  background-color: ${({ theme, __disabled }) =>
    !!__disabled ? theme.colors.gray._200 : theme.colors.white};
  border-radius: 3px;
  height: 20px;
  width: 20px;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.family.default};
  font-size: ${({ theme }) => theme.fonts.size.small};
  font-weight: 800;
  color: ${({ theme, __disabled }) =>
    !!__disabled ? theme.colors.gray._300 : theme.colors.primary._700};
  text-align: center;
`;

const Funcionamento = ({ funcionamento }) => {
  const array = funcionamento.split("");
  return (
    <FlexContainer __gap={"4px"}>
      <Letter disabled={array[0] !== "S"}>D</Letter>
      <Letter disabled={array[1] !== "S"}>S</Letter>
      <Letter disabled={array[2] !== "S"}>T</Letter>
      <Letter disabled={array[3] !== "S"}>Q</Letter>
      <Letter disabled={array[4] !== "S"}>Q</Letter>
      <Letter disabled={array[5] !== "S"}>S</Letter>
      <Letter disabled={array[6] !== "S"}>S</Letter>
    </FlexContainer>
  );
};

const Letter = ({ children, disabled }) => {
  return <LetterContainer __disabled={disabled}>{children}</LetterContainer>;
};

export default Funcionamento;
